/** How long the agent card shows "Running" before the payoff artifact lands —
 * long enough to feel like real work without dragging out the demo. */
export const RUN_DELAY_MS = 5000;
